import { AORTA_INTERPRETATION, MAXIMAL_AORTA } from "../groups/aorta";
import {
  CARDIAC_IMPRESSION,
  CARDIAC_IVC_IMPRESSION,
  cardiacFindings,
} from "../groups/cardiac";
import {
  FAST_INTERPRETATION,
  FAST_LUQ,
  FAST_PELVIS,
  FAST_RUQ,
} from "../groups/fast";
import { ANTERIOR_LUNG, PLEURAL_LINE } from "../groups/thoracic";
import {
  multi,
  OTHER,
  option,
  text,
  type UsWorksheetDefinition,
} from "../us-fields";

export const US_RUSH: UsWorksheetDefinition = {
  examType: "us_rush",
  version: 1,
  indications: [option("shock", "Assessment for etiology of shock state")],
  fixedIndication: true,
  sections: [
    {
      id: "cardiac_findings",
      label: "Cardiac findings",
      role: "findings",
      technicallyLimited: true,
      fields: cardiacFindings("Other"),
    },
    {
      id: "cardiac_impression",
      label: "Cardiac impression",
      role: "impression",
      fields: [CARDIAC_IMPRESSION, CARDIAC_IVC_IMPRESSION],
    },
    {
      id: "thoracic_lung",
      label: "lung",
      role: "findings",
      technicallyLimited: true,
      repeatPerSide: ["right", "left"],
      fields: [
        PLEURAL_LINE,
        ANTERIOR_LUNG,
        text("thoracic.other_findings", "Other"),
      ],
    },
    {
      id: "thoracic_impression",
      label: "Thoracic impression",
      role: "impression",
      fields: [
        multi("thoracic.impression", "Impression", [
          option("normal_thoracic", "Normal thoracic ultrasound"),
          option("pulmonary_edema", "Pulmonary edema"),
          option("pneumothorax", "Pneumothorax", { sided: true }),
          option("indeterminate", "Indeterminate"),
          OTHER,
        ]),
      ],
    },
    {
      id: "aorta_findings",
      label: "Abdominal Aorta findings",
      role: "findings",
      technicallyLimited: true,
      fields: [MAXIMAL_AORTA, text("aorta.other_findings", "Other")],
    },
    {
      id: "aorta_interpretation",
      label: "Abdominal Aorta interpretation",
      role: "impression",
      fields: [AORTA_INTERPRETATION],
    },
    {
      id: "fast_findings",
      label: "FAST findings",
      role: "findings",
      technicallyLimited: true,
      fields: [
        FAST_RUQ,
        FAST_LUQ,
        FAST_PELVIS,
        text("fast.other_findings", "Other"),
      ],
    },
    {
      id: "fast_interpretation",
      label: "FAST interpretation",
      role: "impression",
      fields: [FAST_INTERPRETATION],
    },
  ],
  normalImpressions: [
    { sectionId: "cardiac_impression", value: "normal_cardiac" },
    { sectionId: "thoracic_impression", value: "normal_thoracic" },
    { sectionId: "aorta_interpretation", value: "no_aaa" },
    { sectionId: "fast_interpretation", value: "no_free_fluid" },
  ],
  billing: {
    codes: [
      { cpt: "93308", label: "Echocardiography, limited", preTick: true },
      { cpt: "76604", label: "Chest ultrasound" },
      { cpt: "76775", label: "Abdominal aorta ultrasound, limited" },
      { cpt: "76705", label: "Abdominal ultrasound, limited" },
    ],
  },
};
